/**
 * Een lijst (resultaten, of leerlingen met hun ontwikkeling) per groep, in de
 * volgorde waarin de groepen in de lijst voorkomen.
 *
 *   perGroep(resultaten) → [{ class_id, class_naam, items: [...] }, ...]
 */
export function perGroep(lijst) {
  const groepen = new Map();
  lijst.forEach(item => {
    if (!groepen.has(item.class_id)) {
      groepen.set(item.class_id, { class_id: item.class_id, class_naam: item.class_naam, items: [] });
    }
    groepen.get(item.class_id).items.push(item);
  });
  return [...groepen.values()];
}
